import request from '@/utils/request'

// 删除提现卡
export function deleteWithdrawBankAccount(id) {
  return request({
    url: `/user/withdraw/deleteWithdrawBankAccount/${id}`,
    method: 'delete',
  })
}

// 恢复提现卡
export function recoverWithdrawBankAccount(id) {
  return request({
    url: `/user/withdraw/recoverWithdrawBankAccount/${id}`,
    method: 'post',
  })
}

// 取得提现银行列表
// export function getWithdrawAllowBankList() {
//   return request({
//     url: '/user/withdraw/bankList',
//     method: 'get',
//   })
// }

export function withdrawCommissionToJifen(data) {
  return request({
    url: '/user/withdraw/commissionToJifen',
    method: 'post',
    data: data,
  })
}

export function withdrawAll(data) {
  return request({
    url: '/user/withdraw/withdrawAll',
    method: 'post',
    data: data,
  })
}

export function withdrawCommission(data) {
  return request({
    url: '/user/withdraw/applyWithdrawCommission', // withdrawCommission
    method: 'post',
    data: data,
  })
}

export function withdrawBalance(data) {
  return request({
    url: '/user/withdraw/applyWithdrawBalance', // withdrawBalance
    method: 'post',
    data: data,
  })
}

export function editWithdrawBank(data) {
  return request({
    url: `/user/withdraw/updateBankAccount/${data.id}`,
    method: 'patch',
    data: data,
  })
}

export function addWithdrawBank(data) {
  return request({
    url: '/user/withdraw/addBankAccount',
    method: 'post',
    data: data,
  })
}

export function getWithdrawBankList(params) {
  return request({
    url: '/user/withdraw/bankAccountList',
    method: 'get',
    params: params,
  })
}


// WEBPACK FOOTER //
// ./src/api/withdraw.js